module.exports = __webpack_public_path__ + "static/media/04.e408081a.png";